import { darken, SxProps, Theme } from '@mui/material'

import {
  CHART_CARD_BACKGROUND,
  HEADER_BUTTON_RADIUS_PX,
  INPUT_BORDER,
  NEUTRAL_GREY_500,
} from '@/common/constants'
import { CHART_CARD_TITLE_SX } from '@/common/styles'

/**
 * The main action of the policy page (Edit, Save). White on `primary.main` is 3.2:1, below
 * WCAG AA. On `primary.dark` it is 6:1. Same fill as the Confirm button of `ThemedCreateModal`.
 */
export const PRIMARY_BUTTON_SX = {
  bgcolor: 'primary.dark',
  borderRadius: `${HEADER_BUTTON_RADIUS_PX}px`,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: (theme: Theme) => darken(theme.palette.primary.dark, 0.2),
    boxShadow: 'none',
  },
} satisfies SxProps<Theme>

/**
 * The other actions of the policy page (Publish, Add Time Frame). The same white fill, border
 * and radius as the icon buttons of the page header (`SQUARE_ICON_BUTTON_SX`).
 */
export const SECONDARY_BUTTON_SX = {
  bgcolor: 'common.white',
  border: `1px solid ${INPUT_BORDER}`,
  borderRadius: `${HEADER_BUTTON_RADIUS_PX}px`,
  color: 'primary.dark',
  '&:hover': { bgcolor: CHART_CARD_BACKGROUND, borderColor: INPUT_BORDER },
} satisfies SxProps<Theme>

/** A text button (Cancel, the back link). `primary.main` text on white is only 3.2:1. */
export const TEXT_BUTTON_SX = {
  color: 'primary.dark',
} satisfies SxProps<Theme>

/** The policy name above the cards. Larger than a card title, in the same grey and weight. */
export const POLICY_TITLE_SX = {
  ...CHART_CARD_TITLE_SX,
  fontSize: '24px',
  lineHeight: 1.25,
  // A policy name is user data and can be one long word.
  overflowWrap: 'anywhere',
} satisfies SxProps<Theme>

/** The label above each value or input of the policy form. */
export const FIELD_LABEL_SX = {
  color: NEUTRAL_GREY_500,
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: 1.4,
} satisfies SxProps<Theme>
